import DownChevron from '@img/icons/chevron-down.svg';
import UpChevron from '@img/icons/chevron-up.svg';
import React, { useState, useEffect, useCallback, useMemo, Fragment, } from 'react';
import S from './MobileNavigation.styles';
import { getDropdownItems } from '../helpers';
const MobileNavigation = ({ isActive, items, otherItems = [], }) => {
    const [activeLevel1, setActiveLevel1] = useState(null);
    const [activeLevel2, setActiveLevel2] = useState(null);
    const [activeLevel3, setActiveLevel3] = useState(null);
    // Reset state if navigation is toggled.
    useEffect(() => {
        if (isActive) {
            setActiveLevel1(null);
            setActiveLevel2(null);
            setActiveLevel3(null);
        }
    }, [isActive]);
    const tabIndex = useMemo(() => (isActive ? 0 : -1), [isActive]);
    const onItemClick = useCallback((event, item) => {
        const dropdownItems = getDropdownItems(item);
        if (dropdownItems?.length > 0) {
            event.preventDefault();
            setActiveLevel2(null);
            setActiveLevel3(null);
            if (item.id !== activeLevel1?.id) {
                const levelToSet = item?.children?.length ? item : null;
                setActiveLevel1(levelToSet);
            }
            else {
                setActiveLevel1(null);
            }
        }
    }, [setActiveLevel1, setActiveLevel2, setActiveLevel3, activeLevel1]);
    const onItemKeyDown = useCallback((event) => {
        switch (event.key) {
            case 'ArrowRight':
                setActiveLevel1(activeLevel2);
                break;
            case 'ArrowLeft':
                setActiveLevel1(null);
                setActiveLevel2(null);
                setActiveLevel3(null);
                break;
            default:
                break;
        }
    }, [activeLevel2, setActiveLevel1, setActiveLevel2, setActiveLevel3]);
    const renderItem = useCallback((item) => {
        const dropdownItems = getDropdownItems(item);
        const isActive = item.id === activeLevel1?.id;
        const icon = isActive ? React.createElement(UpChevron, null) : React.createElement(DownChevron, null);
        return (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url, tabIndex: tabIndex, target: item.target },
                React.createElement(S.Text, null, item.text)),
            dropdownItems?.length > 0 && (React.createElement(S.ChevronLink, { href: '#', "data-active": isActive, onKeyDown: onItemKeyDown, onClick: (event) => onItemClick(event, item) }, icon))));
    }, [activeLevel1, onItemClick, onItemKeyDown, tabIndex]);
    const onLevel1Click = useCallback((event, item) => {
        const dropdownItems = getDropdownItems(item);
        if (dropdownItems?.length > 0) {
            event.preventDefault();
            setActiveLevel3(null);
            if (item.id !== activeLevel2?.id) {
                const levelToSet = item?.children?.length ? item : null;
                setActiveLevel2(levelToSet);
            }
            else {
                setActiveLevel2(null);
            }
        }
    }, [setActiveLevel2, setActiveLevel3, activeLevel2]);
    const onLevel1KeyDown = useCallback((event, item) => {
        switch (event.key) {
            case 'ArrowRight':
                setActiveLevel2(item);
                break;
            case 'ArrowLeft':
                setActiveLevel2(null);
                setActiveLevel3(null);
                break;
            default:
                break;
        }
    }, [setActiveLevel2, setActiveLevel3]);
    const renderLevel1Item = useCallback((item) => {
        const dropdownItems = getDropdownItems(item);
        const isActive = item.id === activeLevel2?.id;
        const icon = isActive ? React.createElement(UpChevron, null) : React.createElement(DownChevron, null);
        return (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url, tabIndex: tabIndex, target: item.target },
                React.createElement(S.Text, null, item.text)),
            dropdownItems?.length > 0 && (React.createElement(S.ChevronLink, { href: '#', "data-active": isActive, onClick: (event) => onLevel1Click(event, item), onKeyDown: (event) => onLevel1KeyDown(event, item) }, icon))));
    }, [activeLevel2, onLevel1Click, onLevel1KeyDown, tabIndex]);
    const onLevel2Click = useCallback((event, item) => {
        const dropdownItems = getDropdownItems(item);
        if (dropdownItems?.length > 0) {
            event.preventDefault();
            if (item.id !== activeLevel3?.id) {
                const levelToSet = item?.children?.length ? item : null;
                setActiveLevel3(levelToSet);
            }
            else {
                setActiveLevel3(null);
            }
        }
    }, [setActiveLevel3, activeLevel3]);
    const onLevel2KeyDown = useCallback((event, item) => {
        switch (event.key) {
            case 'ArrowRight':
                setActiveLevel3(item);
                break;
            case 'ArrowLeft':
                setActiveLevel3(null);
                break;
            default:
                break;
        }
    }, [setActiveLevel3]);
    const renderLevel2Item = useCallback((item) => {
        const dropdownItems = getDropdownItems(item);
        const isActive = item.id === activeLevel3?.id;
        const icon = isActive ? React.createElement(UpChevron, null) : React.createElement(DownChevron, null);
        return (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url, tabIndex: tabIndex, target: item.target },
                React.createElement(S.Text, null, item.text)),
            dropdownItems?.length > 0 && (React.createElement(S.ChevronLink, { href: '#', "data-active": isActive, onClick: (event) => onLevel2Click(event, item), onKeyDown: (event) => onLevel2KeyDown(event, item) }, icon))));
    }, [activeLevel3, onLevel2Click, onLevel2KeyDown, tabIndex]);
    const renderLevel3Items = useCallback((item) => {
        if (activeLevel3?.id !== item.id || !activeLevel3?.children?.length) {
            return null;
        }
        return (React.createElement(React.Fragment, null, getDropdownItems(activeLevel3).map((level3Item) => (React.createElement(S.Item, { key: level3Item.id },
            React.createElement(S.Link, { href: level3Item.url, tabIndex: tabIndex, target: level3Item.target },
                React.createElement(S.Text, null, level3Item.text)))))));
    }, [activeLevel3, tabIndex]);
    const renderLevel2Items = useCallback((item) => {
        if (activeLevel2?.id !== item.id || !activeLevel2?.children?.length) {
            return null;
        }
        return (React.createElement(React.Fragment, null, getDropdownItems(activeLevel2).map((level2Item) => (React.createElement(Fragment, { key: level2Item.id },
            renderLevel2Item(level2Item),
            React.createElement(S.Item, null,
                React.createElement(S.SubList, { "data-active": activeLevel3?.id === level2Item.id }, renderLevel3Items(level2Item))))))));
    }, [activeLevel2, activeLevel3, renderLevel2Item, renderLevel3Items]);
    const renderOtherItem = useCallback((item) => (React.createElement(S.Item, { key: item.id },
        React.createElement(S.Link, { href: item.url, tabIndex: tabIndex, target: item.target }, item.text))), [tabIndex]);
    return (React.createElement(S.Container, { "data-m-active": isActive, "aria-hidden": !isActive, "aria-label": "Main Navigation - Mobile" },
        React.createElement(S.List, null,
            items.map((item) => (React.createElement(Fragment, { key: item.id },
                renderItem(item),
                React.createElement(S.Item, null,
                    React.createElement(S.List, { "data-active": activeLevel1?.id === item.id }, activeLevel1?.id === item.id && !!activeLevel1?.children?.length && (React.createElement(React.Fragment, null, getDropdownItems(activeLevel1).map((level1Item) => (React.createElement(Fragment, { key: level1Item.id },
                        renderLevel1Item(level1Item),
                        React.createElement(S.Item, null,
                            React.createElement(S.SubList, { "data-active": activeLevel2?.id === level1Item.id }, renderLevel2Items(level1Item))))))))))))),
            otherItems?.length > 0 && otherItems.map(renderOtherItem))));
};
export default MobileNavigation;
